import {CookieAttributes} from 'js-cookie';

/**
 * Represents a cookie
 */
class Cookie {
	private key: string;
	private value: string;
	private attributes?: CookieAttributes;

	/**
	 * @constructor
	 * @param {String} key - cookie key
	 * @param {String} value - cookie value
	 * @param {CookieAttributes} attributes - cookie attributes
	 */
	constructor(key, value, attributes = {}) {
		this.key = key;
		this.value = value;
		this.attributes = attributes;
	}

	/**
	 * Returns the key
	 * @returns {String} - key
	 */
	getKey(): string {
		return this.key;
	}

	/**
	 * Returns the value
	 * @returns {String} - value
	 */
	getValue(): string {
		return this.value;
	}

	/**
	 * Returns the attributes
	 * @returns {CookieAttributes} - attributes
	 */
	getAttributes(): CookieAttributes {
		return this.attributes;
	}
}

export default Cookie;
